const Modal = function ({
                            title = "",
                            titleSub = "",
                            content,
                            onAppear,
                            onClosing,
                            onClosed,
                            onFailedLoad,
                            showCloseButton = true,
                            closeOnEscape = true,
                            closeOnClickOutside = true,
                            classes = ""
                        } = {}) {
    const titleSubElm = titleSub
        ?
        `<div class="modal__inner__title__title-sub">${titleSub}</div>`
        : '';
    const titleElm = title
        ?
        `<div class="modal__inner__title title">
                <div class="modal__inner__title__main set-h4">${title}</div>
                ${titleSubElm}
             </div>`
        : '';
    const closeElm = (showCloseButton) ? `
        <button type="button" class="modal__close" data-modal-close>
            <svg class="modal__close__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M 7.21875 5.78125 L 5.78125 7.21875 L 14.5625 16 L 5.78125 24.78125 L 7.21875 26.21875 L 16 17.4375 L 24.78125 26.21875 L 26.21875 24.78125 L 17.4375 16 L 26.21875 7.21875 L 24.78125 5.78125 L 16 14.5625 Z"/></svg>
        </button>
    ` : ``;

    const m = document.createElement("div");
    m.classList.add("modal");

    if (classes) {
        classes.split(" ").forEach(cl => m.classList.add(cl));
    }

    m.innerHTML =
        `<div class="modal__inner">
          ${titleElm}
          ${closeElm}
          <div class="modal__content"></div>
        </div>`;

    document.body.appendChild(m);

    const clickedOutsideEvent = (e) => {
        if (!closeOnClickOutside) {
            return;
        }
        if (e.target === m) {
            this.close();
        }
    }

    const destroy = (silent = false) => {
        m.parentNode.removeChild(m);
        Modal.current = null;
        document.querySelector('html').classList.remove('has-overlay');
        document.removeEventListener("click", clickedOutsideEvent);

        if (!silent && typeof onClosed === "function") {
            onClosed();
        }
    };

    const addContent = loadedContent => {
        const container = m.querySelector(".modal__content");

        if (typeof loadedContent === "string") {
            container.innerHTML = loadedContent;
        } else {
            container.appendChild(loadedContent);
        }

        ControlBinders.run(container);

        document.addEventListener("click", clickedOutsideEvent);
        
        _global.initBlock();

        m.querySelectorAll("[data-modal-close]").forEach(closeElm => {
            closeElm.addEventListener("click",
                () => {
                    this.close();
                });
        });

        m.classList.add("modal--open");
        document.querySelector('html').classList.add('has-overlay');

        const focusableElements = container.querySelectorAll(`button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])`);
        if (focusableElements.length > 0) {
            focusableElements[0].focus()
        }

        if (typeof onAppear === "function") {
            onAppear(container);
        }

        document.querySelectorAll('.deck-plan-block').forEach(el => {
            document.querySelectorAll('[data-deckplan-image-media]').forEach(ele => {
                const img = ele.querySelector('img');
                if (img) {
                    img.onload = () => {
                        deckPlanBlock.initBlock(el);
                    }
                }
            })
        });


        document.querySelectorAll('.share-modal').forEach(share => {
            if (typeof addthis !== 'undefined') {
                addthis.init();
                addthis.toolbox();
                if (typeof(window.addthis.layers.refresh) === "function"){
                    addthis.layers.refresh();                    
                }
            }
        });
        
        
        const mContent = m.querySelector('.modal__content');
        if (mContent.scrollHeight > window.innerHeight){
            m.classList.add('modal--scrollbar');
        }
        
        container.addEventListener('scroll', () => {
            
        });

    };

    this.close = (forceClose = false) => {
        const continueClose = () => {
            destroy();
            return Promise.resolve();
        }

        if (forceClose || typeof onClosing !== "function") {
            return continueClose();
        }

        return Promise.resolve(onClosing(m.querySelector(".modal__content")))
            .then(result => {
                if (result !== false) {
                    return continueClose();
                }

                return Promise.reject("Aborted modal close");
            });
    }

    if (Modal.current) {

        const htmlElement = document.querySelector(`html`);
        htmlElement.classList.add(`html--overlay`)
        setTimeout(() => Modal.current.close(true), 500);
        setTimeout(() => {

            Modal.current = this;
            this.closeOnEscape = closeOnEscape;

            Promise.resolve(content)
                .then(addContent, e => {
                    destroy(true);

                    if (typeof onFailedLoad === "function") {
                        onFailedLoad(e);
                    }

                }).then(() => setTimeout(() => htmlElement.classList.remove(`html--overlay`), 500));

        }, 500);

    } else {

        Modal.current = this;
        this.closeOnEscape = closeOnEscape;

        Promise.resolve(content)
            .then(addContent, e => {
                destroy(true);

                if (typeof onFailedLoad === "function") {
                    onFailedLoad(e);
                }
            });

    }

}

document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && Modal.current && Modal.current.closeOnEscape) {
        Modal.current.close();
    }
});

ControlBinders.register("[data-modal]", el => {
    const openModal = () => {
        const modal = new Modal({
            title: el.dataset.modalTitle,
            titleSub: el.dataset.modalTitleSub,
            content: el.dataset.modalMethod === "clone" ?
                document.querySelector(el.dataset.modal).cloneNode(true) :
                fetch(el.dataset.modal).then(response => response.text()),
            showCloseButton: !el.dataset.modalHideClose,
            classes: el.dataset.modalClasses,
            onAppear: container => {
                if (typeof el.dataset.modalOnOpen !== undefined && typeof eval(el.dataset.modalOnOpen) === "function") {
                    return eval(el.dataset.modalOnOpen)(container);
                }
            },
            onClosing: container => {
                if (typeof el.dataset.modalOnClose !== undefined && typeof eval(el.dataset.modalOnClose) === "function") {
                    return eval(el.dataset.modalOnClose)(container);
                }
                return true;
            }
        });
    };

    if (el.dataset.modalAutoload) {
        openModal();
    }

    el.addEventListener("click", function (event) {
        event.stopPropagation();
        openModal();
    });

});